import store from '@/store'
import { replaceDynamicContent } from '../filters/replaceDynamicContent'

export default {
  methods: {
    replaceDynamicContent,
    bindscroll() {
      document.addEventListener('click', (event) => {
        const target = event.target
        if (target && target.hasAttribute('scrollto')) {
          store.commit('SET_SCROLL_POSITION', 0)
        }
      })
    },
    getRealOffset(element, useParent) {
      let elem = element
      let offset = elem.offsetTop
      if (elem) {
        if (useParent) {
          if (elem.parentElement.offsetTop) {
            offset = elem.parentElement.offsetTop
          } else {
            offset = 0
          }
        }
        while (elem.offsetParent) {
          elem = elem.offsetParent
          offset += elem.offsetTop
        }
        return offset
      }
      return 0
    },
    // a simple helper that counts which position the quote is in
    // this is used many times in the content headers e.g. 'Quote 2'
    quotePosition(quote) {
      return this.quotes.indexOf(quote) + 1
    },
    pickProductName({ name }) {
      if (typeof name === 'string') {
        return name
      }

      const lang = this.$store.getters.language
      return name[lang] || name['en']
    },
  },
  created() {
    this.bindscroll()
  },
  computed: {
    config() {
      return this.$store.state.data.configuration
    },
    // all the content keys accessable
    content() {
      return this.$store.getters.content
    },
    iquoteId() {
      // TODO: I'd argue we should remove this (and the iquote below) and get them
      //  via getters, most of which already exist
      return this.$store.state.iquote.iquoteId
    },
    iquote() {
      return this.$store.state.iquote.iquote
    },
    contact() {
      return this.$store.state.iquote.iquote.contact
    },
    quotes() {
      // The data below is still missing sometimes. This is a workaround and not a
      // permanent fix, either the data should not be optional in the GraphQL API or
      // a more elegant way should be found to define the defaults in the front-end.
      const mockEnvironmentalGains = (q) => {
        if (q.environmentalGains === null) {
          return {
            co2: 0,
            trees: 0,
            mileage: 0,
          }
        }

        return q.environmentalGains
      }
      const mockData = (q) => ({
        detailOverview: {
          ...q.detailOverview,
          ...{
            annualSavings: q.detailOverview.annualSavings || [0],
            annualSavingsCumulative: q.detailOverview.annualSavingsCumulative || [0],
            energyGenerated: q.detailOverview.energyGenerated || [0],
          },
        },
        environmentalGains: mockEnvironmentalGains(q),
      })

      let quotes = this.$store.getters.quotes.map((q) => ({
        ...q,
        ...mockData(q),
      }))

      // We want to split up the items of the quotes into different categories so that
      // they can be shown separately in different parts of the quote.
      const mapItemCategories = (items) => {
        const categories = {
          panels: [],
          inverters: [],
          batteries: [],
          optimizers: [],
          environmentalContribution: [],
        }
        // It's possible that the same panel type shows up multiple times with different
        // quantities. In this case we want to add up all the quantities to get a single
        // total number of panels for the quote.
        let totalPanelCount = 0

        items.forEach((item) => {
          let category = item.category && item.category.toLowerCase()

          // Odoo returns the category including spaces, so we need to add this
          // exception if we want easy access to an `environmentalContribution`
          // property.
          if (category === "environmental contribution") {
            category = "environmentalContribution"
          }

          if (category === 'panels') {
            totalPanelCount += item.quantity
            categories[category] = {
              ...item,
              quantity: totalPanelCount,
            }
          } else if (Object.keys(categories).indexOf(category) >= 0) {
            categories[category].push(item)
          }
        })

        return categories
      }

      quotes = quotes.map((q) => ({
        ...q,
        ...mapItemCategories(q.items),
        items: q.items.filter(i => i.category !== 'Environmental Contribution'),
        hasSunsure: q.termsAndConditions && q.termsAndConditions.some((t) => t.type === 'sunsure'),
      }))

      return quotes
    },
    containsAddons() {
      // return if some of containAddons is true in quotes
      if (store.getters.iquote) {
        return store.getters.quotes.some((quotes) => quotes.addons.length)
      }
      return false
    },
    chosenQuote() {
      // get the ordered quote (after downpayment/confirmation only) from the iquote model
      const { chosenQuoteId } = this.$store.state.iquote.iquote

      return this.quotes.find((x) => x.id === chosenQuoteId)
    },
    // helper: check if there are multiple quotes, or one
    multipleQuotes() {
      if (this.$store.getters.iquote && this.$store.getters.quotes) {
        return this.quotes.length > 1
      }
      return false
    },
    trsMode() {
      return this.$store.getters.quoteType === 'TRS'
    },
    installationListItems() {
      const phraseKeys = [
        this.content.pv_infoblock_installation_list_item1,
        this.content.pv_infoblock_installation_list_item2,
        this.content.pv_infoblock_installation_list_item4,
        this.content.pv_infoblock_installation_list_item5,
        this.content.pv_infoblock_installation_list_item6,
        this.content.pv_infoblock_installation_list_item_sun_inspection,
      ]

      return phraseKeys.filter((item) => item && item !== 'OFF')
    },
  },
}
